// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-tooltip__content[data-v-0038fbfc]{background:#fff;color:#000;opacity:1!important}[data-v-0038fbfc] .responses-table{padding:0!important}.no-data[data-v-0038fbfc]{margin:auto}.no-data .chat-date[data-v-0038fbfc]{font-weight:600}", ""]);
// Exports
module.exports = exports;
